import {connect} from "react-redux";
import {FirebaseDatabaseProvider} from "@react-firebase/database";
import React, {useEffect} from "react";
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/database';
import {FirebaseAuthConsumer, FirebaseAuthProvider} from "@react-firebase/auth";
import FirebaseSignatureReducerUpdater from "./FirebaseSignatureReducerUpdater";
import {setFirebaseSignedIn} from "../redux/actions/applicationData";
import {FirebaseService} from "./FirebaseService";

function FirebaseHandler(props) {
    const {
        firebaseData,
        setFirebaseSignedIn,
    } = props;

    const renderFirebase = () => {
        return (
            <section>
                <FirebaseAuthProvider {...firebaseData.firebase} firebase={firebase}>
                    <FirebaseAuthConsumer>
                        {({isSignedIn}) => {
                            setTimeout(() => {
                                setFirebaseSignedIn(isSignedIn);
                            });
                            if (isSignedIn === true) {
                                // Continue to application only if connected to firebase
                                return (<FirebaseDatabaseProvider {...firebaseData.firebase} firebase={firebase}>
                                    <FirebaseSignatureReducerUpdater/>
                                </FirebaseDatabaseProvider>)
                            } else {
                                // Firebase not connected
                                // Realtime db only promises an uptime of 99.95% percent as opposed to the firestore which promises 99.999%
                                // Realtime db was chosen because the existing payment terminal system uses realtime db.

                                // connecting to fire base
                                FirebaseService.signInAnonymously().finally(() => {});

                                return null;
                            }
                        }}
                    </FirebaseAuthConsumer>
                </FirebaseAuthProvider>
            </section>
        );
    }

    // Core answers an unpaired terminal with {identifier, paired: false}, so
    // firebaseData is set but carries no key. Distinguish that from the pre-fetch
    // null: once the gate below closes nothing is mounted to report an auth state,
    // and `firebaseSignedIn` would otherwise keep whatever it last held - `true`
    // from a session that was paired until an admin removed the terminal. The
    // header's spinner does not depend on this; it gates on the api key directly.
    // This is about the value being accurate for anything that reads it.
    const terminalFetched = Boolean(firebaseData);
    const hasApiKey = Boolean(firebaseData?.firebase?.apiKey);

    useEffect(() => {
        if (terminalFetched && !hasApiKey) {
            setFirebaseSignedIn(false);
        }
    }, [terminalFetched, hasApiKey, setFirebaseSignedIn]);

    const renderContent = () => {
        // The api key is fetched with the terminal and is the only part of the
        // config that Core supplies. An unpaired terminal answers with
        // {identifier, paired: false} and no key at all, so gating on the config
        // object alone would mount the providers with apiKey undefined -
        // FirebaseAuthProvider then skips initializeApp and throws from
        // componentDidMount, which the error boundary turns into a reload.
        if (hasApiKey) {
            return renderFirebase();
        }

        return null;
    }

    return renderContent();
}

export default connect(({applicationData}) => ({
    firebaseData: applicationData.firebaseData,
}), {
    setFirebaseSignedIn,
})(FirebaseHandler);